import type { ReactNode } from "react";
import { Card, Wordmark } from "@grackle/ui";

/** Centered-card layout shared by the auth, invite/join and org pages (reset PR2: DS Wordmark
 * and Card on the paper background). The title stays the page's only h1. */
export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <Wordmark size={23} />
        <Card size="lg" className="auth-panel">
          <div className="auth-heading">
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
          {children}
        </Card>
        {footer ? <div className="auth-footer">{footer}</div> : null}
      </div>
    </div>
  );
}
